function DisposalIcon(props) {
  const { isActive } = props
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3333 2.99999H13.6667V4.33333H12.3333V13C12.3333 13.1768 12.2631 13.3464 12.1381 13.4714C12.013 13.5964 11.8435 13.6667 11.6667 13.6667H2.33333C2.15652 13.6667 1.98695 13.5964 1.86193 13.4714C1.73691 13.3464 1.66667 13.1768 1.66667 13V4.33333H0.333334V2.99999H3.66667V0.999995C3.66667 0.823184 3.73691 0.653615 3.86193 0.52859C3.98695 0.403566 4.15652 0.333328 4.33333 0.333328H9.66667C9.84348 0.333328 10.013 0.403566 10.1381 0.52859C10.2631 0.653615 10.3333 0.823184 10.3333 0.999995V2.99999ZM11 4.33333H3V12.3333H11V4.33333ZM7.94267 8.33333L9.12133 9.51199L8.17867 10.4547L7 9.27599L5.82133 10.4547L4.87867 9.51199L6.05733 8.33333L4.87867 7.15466L5.82133 6.21199L7 7.39066L8.17867 6.21199L9.12133 7.15466L7.94267 8.33333ZM5 1.66666V2.99999H9V1.66666H5Z"
        fill={!isActive ? '#828282' : '#FFFFFF'}
      />
    </svg>
  )
}

export default DisposalIcon
